import ge, { useState as A, useEffect as ie, createContext as xe, useContext as ee, useMemo as O, useCallback as he, memo as Oe } from "react";
import { useArchiveLibraryMember as Ie, SpinnerWidgetContainer as ke, ErrorPage as Ne, SpinnerContainer as Fe, NestedInfoWrapper as Le, CustomCodeBaseInfo as Me, FileExplorer as De, ID_COLUMN as be, NAME_COLUMN as Ce, CREATED_COLUMN as Ee, UPDATED_COLUMN as je, AUTHOR_COLUMN as ye, PageList as Ue, FormElement as X, FormActionsContainer as $e, ICON_COLUMN as ze, EntityTypeCell as Be, NameCell as Ye, FloatingButton as We } from "@prometheus/features";
import { useParams as qe, useSearchParams as Ge, Routes as Ve, Route as de } from "react-router-dom";
import { api as k, getSortDirection as He, createBreadcrumbsEntityConfig as Je, createCrudEntityConfig as Xe, createFiltersPanelListConfig as Re, createSortingMethodListConfig as Se, createCrudMethodsListConfig as Qe, populateColumnsConfigWithSort as Ze, separateSearchFilters as Ke } from "@prometheus/utils";
import { Status as v, ListActions as et } from "@prometheus/types";
import { Spinner as le, Grid as b, Block as ve, Select as tt, Input as rt, Textarea as me, Button as Z, Icon as D, Tooltip as nt, NewTable as ot, FilterPanel as st, InputFilter as at, useNotifications as Te, IconButton as it } from "@prometheus/components";
import { TypesOfContainer as K, EntityTypes as lt, EntityIconNames as ct } from "@prometheus/enums";
import { setBreadcrumbs as ut } from "@prometheus/redux";
import { useDispatch as dt } from "react-redux";
import { useEntityNew as mt, useSelectedConcepts as ft, useEntityList as pt, ModalContext as _e } from "@prometheus/hooks";
import gt from "@emotion/styled";
var ae = { exports: {} }, W = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fe;
function xt() {
  if (fe) return W;
  fe = 1;
  var r = Symbol.for("react.transitional.element"), n = Symbol.for("react.fragment");
  function o(s, i, u) {
    var m = null;
    if (u !== void 0 && (m = "" + u), i.key !== void 0 && (m = "" + i.key), "key" in i) {
      u = {};
      for (var d in i)
        d !== "key" && (u[d] = i[d]);
    } else u = i;
    return i = u.ref, {
      $$typeof: r,
      type: s,
      key: m,
      ref: i !== void 0 ? i : null,
      props: u
    };
  }
  return W.Fragment = n, W.jsx = o, W.jsxs = o, W;
}
var q = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var pe;
function ht() {
  return pe || (pe = 1, process.env.NODE_ENV !== "production" && function() {
    function r(e) {
      if (e == null) return null;
      if (typeof e == "function")
        return e.$$typeof === ue ? null : e.displayName || e.name || null;
      if (typeof e == "string") return e;
      switch (e) {
        case f:
          return "Fragment";
        case p:
          return "Profiler";
        case c:
          return "StrictMode";
        case I:
          return "Suspense";
        case U:
          return "SuspenseList";
        case te:
          return "Activity";
      }
      if (typeof e == "object")
        switch (typeof e.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), e.$$typeof) {
          case P:
            return "Portal";
          case h:
            return (e.displayName || "Context") + ".Provider";
          case w:
            return (e._context.displayName || "Context") + ".Consumer";
          case N:
            var a = e.render;
            return e = e.displayName, e || (e = a.displayName || a.name || "", e = e !== "" ? "ForwardRef(" + e + ")" : "ForwardRef"), e;
          case F:
            return a = e.displayName || null, a !== null ? a : r(e.type) || "Memo";
          case $:
            a = e._payload, e = e._init;
            try {
              return r(e(a));
            } catch {
            }
        }
      return null;
    }
    function n(e) {
      return "" + e;
    }
    function o(e) {
      try {
        n(e);
        var a = !1;
      } catch {
        a = !0;
      }
      if (a) {
        a = console;
        var l = a.error, g = typeof Symbol == "function" && Symbol.toStringTag && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return l.call(
          a,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          g
        ), n(e);
      }
    }
    function s(e) {
      if (e === f) return "<>";
      if (typeof e == "object" && e !== null && e.$$typeof === $)
        return "<...>";
      try {
        var a = r(e);
        return a ? "<" + a + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function i() {
      var e = G.A;
      return e === null ? null : e.getOwner();
    }
    function u() {
      return Error("react-stack-top-frame");
    }
    function m(e) {
      if (re.call(e, "key")) {
        var a = Object.getOwnPropertyDescriptor(e, "key").get;
        if (a && a.isReactWarning) return !1;
      }
      return e.key !== void 0;
    }
    function d(e, a) {
      function l() {
        z || (z = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          a
        ));
      }
      l.isReactWarning = !0, Object.defineProperty(e, "key", {
        get: l,
        configurable: !0
      });
    }
    function E() {
      var e = r(this.type);
      return B[e] || (B[e] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), e = this.props.ref, e !== void 0 ? e : null;
    }
    function x(e, a, l, g, T, S, ne, oe) {
      return l = S.ref, e = {
        $$typeof: R,
        type: e,
        key: a,
        props: S,
        _owner: T
      }, (l !== void 0 ? l : null) !== null ? Object.defineProperty(e, "ref", {
        enumerable: !1,
        get: E
      }) : Object.defineProperty(e, "ref", { enumerable: !1, value: null }), e._store = {}, Object.defineProperty(e._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(e, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(e, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: ne
      }), Object.defineProperty(e, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: oe
      }), Object.freeze && (Object.freeze(e.props), Object.freeze(e)), e;
    }
    function C(e, a, l, g, T, S, ne, oe) {
      var j = a.children;
      if (j !== void 0)
        if (g)
          if (V(j)) {
            for (g = 0; g < j.length; g++)
              _(j[g]);
            Object.freeze && Object.freeze(j);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else _(j);
      if (re.call(a, "key")) {
        j = r(e);
        var M = Object.keys(a).filter(function(Ae) {
          return Ae !== "key";
        });
        g = 0 < M.length ? "{key: someKey, " + M.join(": ..., ") + ": ...}" : "{key: someKey}", Y[j + g] || (M = 0 < M.length ? "{" + M.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          g,
          j,
          M,
          j
        ), Y[j + g] = !0);
      }
      if (j = null, l !== void 0 && (o(l), j = "" + l), m(a) && (o(a.key), j = "" + a.key), "key" in a) {
        l = {};
        for (var se in a)
          se !== "key" && (l[se] = a[se]);
      } else l = a;
      return j && d(
        l,
        typeof e == "function" ? e.displayName || e.name || "Unknown" : e
      ), x(
        e,
        j,
        S,
        T,
        i(),
        l,
        ne,
        oe
      );
    }
    function _(e) {
      typeof e == "object" && e !== null && e.$$typeof === R && e._store && (e._store.validated = 1);
    }
    var y = ge, R = Symbol.for("react.transitional.element"), P = Symbol.for("react.portal"), f = Symbol.for("react.fragment"), c = Symbol.for("react.strict_mode"), p = Symbol.for("react.profiler"), w = Symbol.for("react.consumer"), h = Symbol.for("react.context"), N = Symbol.for("react.forward_ref"), I = Symbol.for("react.suspense"), U = Symbol.for("react.suspense_list"), F = Symbol.for("react.memo"), $ = Symbol.for("react.lazy"), te = Symbol.for("react.activity"), ue = Symbol.for("react.client.reference"), G = y.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, re = Object.prototype.hasOwnProperty, V = Array.isArray, L = console.createTask ? console.createTask : function() {
      return null;
    };
    y = {
      react_stack_bottom_frame: function(e) {
        return e();
      }
    };
    var z, B = {}, H = y.react_stack_bottom_frame.bind(
      y,
      u
    )(), J = L(s(u)), Y = {};
    q.Fragment = f, q.jsx = function(e, a, l, g, T) {
      var S = 1e4 > G.recentlyCreatedOwnerStacks++;
      return C(
        e,
        a,
        l,
        !1,
        g,
        T,
        S ? Error("react-stack-top-frame") : H,
        S ? L(s(e)) : J
      );
    }, q.jsxs = function(e, a, l, g, T) {
      var S = 1e4 > G.recentlyCreatedOwnerStacks++;
      return C(
        e,
        a,
        l,
        !0,
        g,
        T,
        S ? Error("react-stack-top-frame") : H,
        S ? L(s(e)) : J
      );
    };
  }()), q;
}
process.env.NODE_ENV === "production" ? ae.exports = xt() : ae.exports = ht();
var t = ae.exports;
const bt = (r) => k.post("/library/custom-code/invites/zip", r), Ct = (r) => k.post("/library/custom-code/invites", r), Q = (r) => {
  const { pageNumber: n, pageSize: o, sortBy: s, query: i } = r, u = He(s), m = `/library/custom-code/list?size=${o || ""}&page=${n || ""}&sort=${u}&${i || ""}`;
  return k.get(m);
}, Pe = (r) => {
  const n = `/library/custom-code/filter?${r}`;
  return k.get(n);
}, we = () => k.get("/library/custom-code/sorts"), Et = (r) => k.get(`/analysis/custom-code/${r}`), jt = (r) => k.get(`/analysis/custom-code/${r}/files`), yt = "New cohort definition", Rt = {
  createCrudEntity: (r, n) => Xe(
    r,
    n,
    Et,
    (o) => Promise.resolve(),
    () => Promise.resolve()
  ),
  entityBreadcrumbs: (r, n, o, s) => Je(yt, r, n, o)
}, St = (r, n) => {
  const [o, s] = A(null), [i, u] = A(v.INITIAL), [m, d] = A([]), [E, x] = A(null), C = mt(n, r, "Custom code"), _ = async () => {
    try {
      const y = await jt(r);
      d(
        y.map((R) => ({
          ...R,
          fileMetadata: R.metadata
        }))
      ), u(v.SUCCESS);
    } catch (y) {
      u(v.ERROR), x({
        response: y
      });
    }
  };
  return ie(() => {
    u(v.IN_PROGRESS), C.status === v.SUCCESS && (console.log(C), s(C.entity), _()), C.status === v.ERROR && (u(v.ERROR), x({
      response: { message: "Base entity is broken" }
    }));
  }, [C.status]), {
    entity: o,
    files: m,
    status: i,
    error: E,
    actions: {}
  };
};
xe({});
const vt = () => {
  const { id: r } = qe(), n = dt(), [o] = Ge(), { rootSettings: s, path: i, title: u, config: m, subModules: d } = ee(
    ce
  ), { rootPath: E, rootTitle: x } = s, { parentId: C, parentTitle: _, typeContainer: y } = m, { createCrudEntity: R, entityBreadcrumbs: P } = Rt, f = O(() => R(y, C), [C]), { entity: c, actions: p, error: w, files: h, status: N } = St(r, {
    get: f.getMethod,
    update: f.upsertMethod,
    delete: f.deleteMethod
  }), I = y === K.LIBRARY, U = Ie(c == null ? void 0 : c.id, I, i);
  c != null && c.actions && p != null && p[et.UPDATE];
  const F = o.get("from") && o.get("from") === K.LIBRARY;
  return ie(() => {
    c && n(
      ut(
        P(
          r,
          c == null ? void 0 : c.title,
          {
            path: i,
            title: u,
            rootPath: E,
            rootTitle: x,
            parentTitle: _,
            parentId: C
          },
          I
        )
      )
    );
  }, [i, c]), N === v.ERROR ? /* @__PURE__ */ t.jsx(ke, { children: /* @__PURE__ */ t.jsx(Ne, { ...w.response, path: i }) }) : N === v.INITIAL || N === v.IN_PROGRESS ? /* @__PURE__ */ t.jsx(Fe, { children: /* @__PURE__ */ t.jsx(le, { size: 62 }) }) : /* @__PURE__ */ t.jsxs(b, { container: !0, px: 6, flexGrow: 1, flexDirection: "column", children: [
    /* @__PURE__ */ t.jsx(Le, { children: /* @__PURE__ */ t.jsx(
      Me,
      {
        entity: c,
        onSubmit: () => {
        },
        onCopy: function($) {
        },
        versionPreview: !1,
        onVersionSave: function() {
        },
        viewMode: I,
        onDelete: function() {
          console.log("Function not implemented.");
        },
        onPublish: function() {
          console.log("Function not implemented.");
        },
        onArchive: U,
        backToListPath: F ? "../../" : "",
        AdditionalActions: F && /* @__PURE__ */ t.jsx(
          d.library,
          {
            type: "component",
            name: "answer-publish-widget",
            subModules: d,
            config: {
              ...m,
              type: o.get("typePublish"),
              typeEntity: lt.CUSTOM_CODE,
              nameEntity: c == null ? void 0 : c.title,
              id: o.get("id"),
              isRedirect: !0,
              requestStatus: o.get("status")
            }
          }
        )
      }
    ) }),
    /* @__PURE__ */ t.jsx(b, { container: !0, children: /* @__PURE__ */ t.jsx(b, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
      De,
      {
        submissionId: c == null ? void 0 : c.id,
        url: "analysis/custom-code",
        files: h,
        heightCount: 150
      }
    ) }) })
  ] });
}, ce = xe(null), Tt = (r) => {
  const { path: n, title: o, rootSettings: s } = r, i = O(() => s || { rootPath: n, rootTitle: o }, [s, n, o]);
  return /* @__PURE__ */ t.jsx(ce.Provider, { value: { ...r, rootSettings: i }, children: /* @__PURE__ */ t.jsxs(Ve, { children: [
    /* @__PURE__ */ t.jsx(de, { index: !0, element: /* @__PURE__ */ t.jsx(Pt, {}) }),
    /* @__PURE__ */ t.jsx(de, { path: ":id/*", element: /* @__PURE__ */ t.jsx(vt, {}) })
  ] }) });
}, _t = {
  rowId: "id",
  loadingMessage: "Loading cutom code...",
  addButtonTitle: "Add feature analysis",
  tableTitle: "Custom code",
  importButtonTitle: "Import",
  listInitialSort: { id: "modified.timestamp", desc: !0 },
  createCrudMethod: (r, n) => Qe(
    r,
    n,
    Q,
    () => Promise.resolve(),
    () => Promise.resolve(""),
    Q,
    Q
  ),
  cols: [
    be(),
    Ce({
      accessor: "title",
      accessorKey: "title"
    }),
    Ee(),
    je(),
    ye()
  ],
  createSortingMethod(r) {
    return Se(r, {
      getSorting: we
    });
  },
  createFiltersPanel: (r, n) => Re(
    r,
    n,
    () => Promise.resolve(""),
    () => Promise.resolve(""),
    () => Promise.resolve(""),
    Pe
  )
  // TODO add sorting
}, Pt = () => {
  const r = ee(
    ce
  );
  return /* @__PURE__ */ t.jsx(
    Ue,
    {
      isImport: !1,
      moduleConfig: r,
      listConfig: _t,
      allowDelete: !0
    }
  );
}, wt = {
  title: "",
  description: "",
  executableFileName: void 0,
  files: [],
  message: ""
}, At = ({
  onSubmit: r,
  onCancel: n,
  subModules: o
}) => {
  const [s, i] = A(wt), [u, m] = A([]), [d, E] = A(), [x, C] = A(!1), _ = O(() => !!(s.title && s.executableFileName), [s, x]), y = O(
    () => o == null ? void 0 : o.documents,
    [o == null ? void 0 : o.documents]
  ), R = he(async () => {
    const { message: f, ...c } = s;
    C(!0);
    try {
      const p = new FormData();
      p.append(
        "dto",
        new Blob([JSON.stringify(c)], {
          type: "application/json"
        })
      ), p.append("message", f || ""), Array.isArray(d) ? d == null || d.forEach((h) => p.append("files", h)) : p.append("file", d);
      const w = Array.isArray(d) ? await Ct(p) : await bt(p);
      r(w);
    } catch (p) {
      console.log(p), r(null);
    } finally {
      n(), C(!1);
    }
  }, [r, s]), P = (f, c) => {
    const p = typeof c == "string" ? c : c.currentTarget.value;
    i((w) => ({
      ...w,
      [f]: p
    }));
  };
  return /* @__PURE__ */ t.jsxs(b, { container: !0, children: [
    /* @__PURE__ */ t.jsx(
      b,
      {
        item: !0,
        xs: 12,
        px: 2,
        sx: (f) => ({
          boxShadow: f.customShadows[2],
          background: "white"
        })
      }
    ),
    /* @__PURE__ */ t.jsx(b, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ t.jsx(ve, { children: /* @__PURE__ */ t.jsxs(b, { container: !0, spacing: 2, p: 2, children: [
      /* @__PURE__ */ t.jsx(b, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        y,
        {
          type: "component",
          name: "upload-new-document",
          subModules: o,
          config: {
            freeUpload: !0,
            onChange: (f, c) => {
              const p = c ? Object.keys(c.files) : f;
              m((w) => p.map((h) => c ? c.files[h] : h).filter((h) => h.name.toLowerCase().includes(".sql") || h.name.toLowerCase().includes(".r")).map((h) => ({
                name: h.name,
                value: h.name
              }))), E(f);
            },
            localDownload: !0,
            textAvailableExt: "ZIP or bunch of SQL and R files"
          }
        }
      ) }),
      /* @__PURE__ */ t.jsx(b, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(X, { name: "type", textLabel: "Entry point", required: !0, children: /* @__PURE__ */ t.jsx(
        tt,
        {
          className: "",
          name: "entry-point",
          disablePortal: !0,
          id: "entry point",
          options: u,
          value: s.executableFileName,
          placeholder: "Select entry point...",
          onChange: (f) => P("executableFileName", f),
          fullWidth: !0
        }
      ) }) }),
      /* @__PURE__ */ t.jsx(b, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(
        X,
        {
          name: "analysis-name",
          textLabel: "Analysis name",
          required: !0,
          children: /* @__PURE__ */ t.jsx(
            rt,
            {
              id: "analysis-name",
              name: "analysis-name",
              type: "text",
              size: "medium",
              onChange: (f) => P("title", f),
              value: s.title,
              fullWidth: !0
            }
          )
        }
      ) }),
      /* @__PURE__ */ t.jsx(b, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(X, { name: "description", textLabel: "Description", children: /* @__PURE__ */ t.jsx(
        me,
        {
          id: "description",
          name: "description",
          value: s.description,
          onChange: (f) => P("description", f),
          maxRows: 10,
          minRows: 5,
          disableHorizontalResize: !0,
          placeholder: "Enter description"
        }
      ) }) }),
      /* @__PURE__ */ t.jsx(b, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsx(X, { name: "message", textLabel: "Message", children: /* @__PURE__ */ t.jsx(
        me,
        {
          id: "message",
          name: "message",
          value: s.message,
          onChange: (f) => P("message", f),
          maxRows: 5,
          minRows: 3,
          disableHorizontalResize: !0,
          placeholder: "Enter message"
        }
      ) }) }),
      /* @__PURE__ */ t.jsx(b, { item: !0, xs: 12, children: /* @__PURE__ */ t.jsxs($e, { children: [
        /* @__PURE__ */ t.jsx(
          Z,
          {
            variant: "outlined",
            onClick: n,
            startIcon: /* @__PURE__ */ t.jsx(D, { iconName: "deactivate" }),
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ t.jsx(
          Z,
          {
            onClick: R,
            variant: "contained",
            disabled: !_ || x,
            color: "success",
            startIcon: x ? /* @__PURE__ */ t.jsx(le, { size: 16 }) : /* @__PURE__ */ t.jsx(D, { iconName: "submit" }),
            children: "Submit"
          }
        )
      ] }) })
    ] }) }) })
  ] });
}, Ot = {
  createCrudMethod: (r, n) => ({
    fetch: (o, s, i, u) => {
      switch (r) {
        case K.STUDY:
        case K.WORKSPACE:
        default:
          return Q({
            pageNumber: o,
            pageSize: s,
            sortBy: i,
            query: u
          });
      }
    }
  }),
  createFiltersPanel: (r, n) => Re(
    r,
    n,
    Pe
  ),
  createSortingMethod(r) {
    return Se(r, {
      getSorting: we
    });
  },
  cols: [
    ze({
      Header: "",
      accessorFn: () => ct.CUSTOM_CODE,
      id: "typeEntityIcon",
      width: "2%",
      cell: Be
    }),
    be(),
    Ce({
      width: "20%",
      cell: (r) => {
        var n, o, s, i;
        return /* @__PURE__ */ t.jsx(
          nt,
          {
            text: (o = (n = r.row) == null ? void 0 : n.original) == null ? void 0 : o.description,
            color: "primary",
            width: "auto",
            children: /* @__PURE__ */ t.jsx("div", { children: /* @__PURE__ */ t.jsx(Ye, { value: (i = (s = r.row) == null ? void 0 : s.original) == null ? void 0 : i.title }) })
          }
        );
      }
    }),
    Ee(),
    je(),
    ye()
  ]
}, It = (r) => {
  const {
    onChange: n,
    typeContainer: o,
    parentId: s,
    isSelect: i = !1,
    onClose: u
  } = r, {
    createCrudMethod: m,
    createFiltersPanel: d,
    createSortingMethod: E,
    cols: x
  } = Ot, C = O(() => m(o, s), [o, s]), _ = O(() => d(o, s), [o, s]), y = O(() => E == null ? void 0 : E(o), [o, s]), {
    selectedConcepts: R,
    detectSelectedAction: P,
    updateSelectedConcept: f,
    clear: c
  } = ft({}, "id"), {
    data: { tableData: p, filtersData: w },
    filters: h,
    actions: N,
    pageCount: I,
    pageSize: U,
    isLoading: F,
    getEntity: $,
    totalElements: te,
    numberOfElements: ue,
    removeEntity: G,
    isReloadLoading: re,
    updateFilters: V,
    allowedSorting: L,
    status: z
  } = pt(
    {
      get: C.fetch,
      remove: () => {
      },
      getFilters: _.getFilters,
      getSorting: y
    },
    "",
    !1
  ), B = (l) => {
    console.log(l), n(i ? Object.keys(R) : [l.original]), u();
  }, H = he((l, g) => {
    const T = {};
    l == null || l.forEach((S) => {
      T[S.id] = S;
    }), P(T, g);
  }, []), J = O(
    () => Ze(x, L),
    [L]
  ), Y = Object.keys(R).length, { otherFilters: e, searchFilter: a } = Ke(w);
  return /* @__PURE__ */ t.jsx(b, { container: !0, children: /* @__PURE__ */ t.jsx(ve, { elevated: !0, outlined: !0, children: /* @__PURE__ */ t.jsxs(b, { container: !0, className: "table-list-features-widget", pb: 0, children: [
    /* @__PURE__ */ t.jsx(
      We,
      {
        onAdd: () => {
          B();
        },
        onClear: c,
        selectedConceptsCount: Y,
        buttonText: "Add feature to analysis",
        width: Y != null ? "calc(100% - 250px)" : window.innerWidth - 250 + "px"
      }
    ),
    /* @__PURE__ */ t.jsx(b, { item: !0, xs: 12, p: 2, children: /* @__PURE__ */ t.jsx(
      ot,
      {
        enableRowSelection: i,
        variant: "controlled",
        noDataText: "No data currently available",
        data: p,
        columns: J,
        pageCount: I,
        pageSize: U,
        loading: F,
        loadingMessage: "",
        fetchData: $,
        totalElements: te,
        selectedRowIds: R,
        onRowSelect: H,
        onRowClick: i ? () => {
        } : B,
        getRowId: (l) => String(l.id),
        showFilterToggle: !0,
        searchComponent: a && /* @__PURE__ */ t.jsx(
          at,
          {
            ...a,
            value: h == null ? void 0 : h[a == null ? void 0 : a.name],
            onChange: (l) => V({ [a == null ? void 0 : a.name]: l })
          }
        ),
        children: /* @__PURE__ */ t.jsx(
          st,
          {
            showLabel: !0,
            filters: e,
            value: h,
            onChange: (l, g) => V({ [l]: g }),
            isLoading: z === v.IN_PROGRESS,
            isReloading: z === v.IN_PROGRESS_RELOAD
          }
        )
      }
    ) })
  ] }) }) });
}, kt = (r) => {
  const { openModal: n, closeModal: o } = ee(_e), { enqueueSnackbar: s } = Te(), i = (m) => {
    if (console.log(m), !m) {
      s(m.message, { variant: "error" });
      return;
    }
    s("Custom code submission successfully created.", {
      variant: "success"
    });
  }, u = () => {
    n(
      () => /* @__PURE__ */ t.jsx(
        At,
        {
          subModules: r.subModules,
          onCancel: o,
          onSubmit: i
        }
      ),
      "Publish custom analysis code",
      {
        closeOnClickOutside: !0,
        width: "700px",
        onClose: o
      }
    );
  };
  return /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsx(
    Z,
    {
      variant: "outlined",
      onClick: u,
      startIcon: /* @__PURE__ */ t.jsx(D, { iconName: "publish" }),
      name: "delete",
      children: "Publish"
    }
  ) });
}, Nt = (r) => {
  const { onChange: n, isLoading: o } = r, { openModal: s, closeModal: i } = ee(_e), { enqueueSnackbar: u } = Te(), m = () => {
    s(
      () => /* @__PURE__ */ t.jsx(It, { onChange: n, onClose: i }),
      "Import custom code",
      {
        onClose: i,
        closeOnClickOutside: !0
      }
    );
  };
  return /* @__PURE__ */ t.jsx(t.Fragment, { children: /* @__PURE__ */ t.jsx(
    Z,
    {
      variant: "contained",
      color: "info",
      onClick: m,
      startIcon: o ? /* @__PURE__ */ t.jsx(le, { size: 16 }) : /* @__PURE__ */ t.jsx(D, { iconName: "download", sx: { transform: "rotate(180deg)" } }),
      name: "delete",
      disabled: o,
      sx: {
        ml: 1.5,
        px: 2,
        borderColor: "borderColor.main",
        ".start-icon-small svg": {
          fontSize: 16
        }
      },
      children: "Import custom code"
    }
  ) });
}, Ft = gt(b, {
  shouldForwardProp: (r) => r !== "isActive"
})`
  font-size: 14px;
  color: ${({ theme: r }) => {
  var n;
  return (n = r.palette) == null ? void 0 : n.primary.main;
}};
  font-weight: 400;
  border-bottom: 1px solid
    ${({ theme: r }) => r.palette.borderColor.light};
  position: relative;
  background-color: ${({ isActive: r, theme: n }) => r ? n.palette.info.main + 20 : "transparent"};
  :hover {
    background-color: ${({ theme: r, isActive: n }) => r.palette.info.main + (n ? 20 : 10)};
  }
  span {
    display: inline-block;
    position: relative;
    top: -6px;
    margin-left: 6px;
  }
`, Lt = (r) => {
  const { initialState: n, onChange: o } = r, [s, i] = A({}), [u, m] = A(!1);
  return ie(() => {
    m(!0), console.log(n);
    const d = n.reduce((E, x) => (E[x] || (E[x] = {}), E[x] = { id: x, name: "Name" + x, version: "version" + x }, E), {});
    i(d);
  }, [n]), /* @__PURE__ */ t.jsx(b, { container: !0, children: Object.values(s).map((d) => /* @__PURE__ */ t.jsx(b, { item: !0, container: !0, xs: 12, children: /* @__PURE__ */ t.jsxs(Ft, { xs: 12, px: 1, py: 0.5, children: [
    /* @__PURE__ */ t.jsx(D, { iconName: "info", sx: { fontSize: 26 } }),
    /* @__PURE__ */ t.jsx("span", { children: d.name }),
    /* @__PURE__ */ t.jsx("span", { children: d.version }),
    /* @__PURE__ */ t.jsx(
      it,
      {
        size: "small",
        onClick: () => {
          o([d.id]);
        },
        children: /* @__PURE__ */ t.jsx(D, { iconName: "delete", sx: { fontSize: 26 } })
      }
    )
  ] }, d.id) }, d.id)) });
}, Mt = Oe((r) => {
  const { name: n, config: o, ...s } = r, { instanceId: i, initialState: u, onChange: m, isLoading: d } = o;
  return /* @__PURE__ */ t.jsxs(ge.Fragment, { children: [
    n === "publish-custom-code" && /* @__PURE__ */ t.jsx(kt, { ...s }),
    n === "add-custom-code-button" && /* @__PURE__ */ t.jsx(
      Nt,
      {
        ...s,
        onChange: m,
        instanceId: i,
        isLoading: d
      }
    ),
    n === "list-current-custom-code" && /* @__PURE__ */ t.jsx(
      Lt,
      {
        instanceId: i,
        initialState: u,
        onChange: m,
        ...s
      }
    )
  ] });
}), Jt = (r) => {
  const { type: n } = r;
  return /* @__PURE__ */ t.jsxs(t.Fragment, { children: [
    !n && /* @__PURE__ */ t.jsx(Tt, { ...r }),
    n === "component" && /* @__PURE__ */ t.jsx(Mt, { ...r })
  ] });
};
export {
  Jt as CustomCode
};
//# sourceMappingURL=custom-code.js.map
